// extracted by mini-css-extract-plugin
module.exports = {"ul":"RichUnorderedList_ul__7Vpxi","withSpace":"RichUnorderedList_withSpace__ilKdH"};